import api from './index'

export default function getCommercialOfferPdf(
  commercialOffer,
  country,
  service = 'proposal'
) {
  return api.post(`/api/${country}/${service}/print`, commercialOffer, {
    responseType: 'blob',
  })
}
